import type {
  Company as CompanyModel,
  Role as RoleModel,
  Team as TeamModel,
  User as UserModel,
  UserGroup,
} from 'api/models';

export interface MentionItem {
  id: string;
  objectId: number;
  type: MentionType;
  subType?: string;
  projectId: number;
  spaceId: number;
  identifier: string;
  photoUrl?: string;
  initials?: string;
  name: string;
  link?: string;
  data?: UserModel | TeamModel | RoleModel | CompanyModel | UserGroup;
}

export interface Suggestion {
  name: string;
  nameEle?: React.ReactElement;
  photoUrl?: string;
  logoUrl?: string;
  avatar?: React.ReactNode;
  type: MentionType;
  subType?: string;
  objectId: number;
  projectId?: number;
  spaceId?: number;
  data?: UserModel | TeamModel | RoleModel | CompanyModel | UserGroup;
}

export enum MentionType {
  Document = 'DOCUMENT',
  SpaceTab = 'SPACE_TAB',
  Task = 'TASK',
  User = 'USER',
  Team = 'TEAM',
  Role = 'ROLE',
  Group = 'GROUP',
  Vendor = 'VENDOR',
  Client = 'CLIENT',
  Company = 'COMPANY',
}

export type MentionSuggestion = string | MentionItem;
export type AsyncSuggester = (onQuery: string) => Promise<MentionSuggestion[]>;
export type Suggester = MentionSuggestion[] | AsyncSuggester;

export const mention = (
  feed: Suggester,
  marker = '@',
  minimumCharacters = 1,
) => ({
  feeds: [
    {
      marker,
      minimumCharacters,
      feed,
    },
  ],
});

export interface Feed {
  marker: string;
  minimumCharacters?: number;
}
